import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const customStyles = {
  menuItem: {
    padding: "18px",
  },
  active: {
    borderBottom: "3px solid rgba(98, 195, 238, 1)",
    color: "rgba(98, 195, 238, 1)",
  },
};

const menuConstructor = (t, navigate) => [
  {
    action: () => navigate("/teachers-reports"),
    label: `${t("Teachers reports")}`,
    name: "/teachers-reports",
  },
  {
    action: () => navigate("/grades-reports"),
    label: `${t("Grades reports")}`,
    name: "/grades-reports",
  },
  {
    action: () => navigate("/other-reports"),
    label: `${t("Other reports")}`,
    name: "/other-reports",
  },
  {
    action: () => navigate("/accounts/teachers"),
    label: t("Accounts"),
    name: "/accounts",
  },
];

function HeaderMenu() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const menuList = menuConstructor(t, navigate);
  let { pathname: url } = useLocation();
  return (
    <List
      sx={{
        display: "flex",
        alignItems: "center",
        color: "rgba(105, 123, 140, 1)",
        fontSize: "18px",
        margin: "0 2rem",
        "@media screen and (max-width: 1023px)": {
          "& *": {
            fontSize: "12px !important",
            lineHeight: 2,
          },
        },
      }}
    >
      {menuList.map((item, index) => (
        <ListItemButton
          sx={{
            ...customStyles.menuItem,
            ...(url.includes(item.name) ? customStyles.active : {}),
          }}
          key={"report_type" + index}
          onClick={item.action}
        >
          <ListItemText primary={item.label} />
        </ListItemButton>
      ))}
    </List>
  );
}

export default HeaderMenu;
